import React from 'react';

export const VennDiagram = () => {
  return (
    <div className="venn-diagram-container">
        <div className="circle circle-1">
            <span className="circle-label">Software Development</span>
        </div>
        <div className="circle circle-2">
            <span className="circle-label">Product Design</span>
        </div>
        <div className="circle circle-3">
            <span className="circle-label">Product Management</span>
        </div>

        <div className="intersection-label circle-label">
            <span>What I Do</span>
        </div>
    </div>
  )
}
